import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { ApplicationUser } from '../models/classes/users/ApplicationUser';
import { IdentityToken } from '../models/classes/users/IdentityToken';

/**
 * The authentication service injection token.
 */
export const AUTHENTICATION_SERVICE = new InjectionToken<IAuthenticationService>('AUTHENTICATION_SERVICE');

export interface IAuthenticationService {

    // tslint:disable-next-line:member-ordering
    credentials$: Observable<IdentityToken>;

    get user(): ApplicationUser;

    get ticket(): any;

    hasRole(group: string): boolean;

    hasNotRole(group: string): boolean;

    hasAnyRole(groups: string[]): boolean;

    isCompanyAdministrator(): boolean;
    /**
     * If user email starts with julien, the user is super admin
     * @returns true if user email starts with julien otherwise return false
     */
    isSuperAdmin(): boolean;

    isAdministrator(): boolean;

    isAnyAdministrator(): boolean;

    /**
     * Logs out the user and clear credentials.
     * @return True if the user was logged out successfully.
     */
    logout(): Observable<boolean>;

    /**
     * Checks is the user is authenticated.
     * @return True if the user is authenticated.
     */
    isAuthenticated(): boolean;

    /**
     * Gets the user credentials.
     * @return The user credentials or null if the user is not authenticated.
     */
    get credentials(): IdentityToken | null;

    /**
     * Sets the user credentials.
     * The credentials may be persisted across sessions by setting the `remember` parameter to true.
     * Otherwise, the credentials are only persisted for the current session.
     * @param credentials The user credentials.
     * @param remember True to remember credentials across sessions.
     */
    setCredentials(credentials?: IdentityToken, remember?: boolean): void;

    checkLoginStatusOrLogin(): Promise<any>;
}